<template>
    <isc-dropdown
        class="header-drop-menu"
        @visible-change="onVisibleChange"
        @command="(command) => $emit('command', command)"
    >
        <header-action :active="active">
            {{ label }}
            <template #append>
                <slot name="append"></slot>
            </template>
        </header-action>

        <isc-dropdown-menu slot="dropdown" class="header-drop-menu__dropdown">
            <slot></slot>
        </isc-dropdown-menu>
    </isc-dropdown>
</template>

<script>
import HeaderAction from '@/components/desk-header/header-action';

export default {
    name: 'HeaderDropMenu',

    components: { HeaderAction },

    props: {
        label: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            active: false
        };
    },

    methods: {
        onVisibleChange(visible) {
            this.active = visible;
        }
    }
};
</script>

<style lang="scss" scoped>
.header-drop-menu {
    height: auto;
    display: inline-flex;

    &__dropdown {
        background: #24252c;
        border-radius: 4px;
        border: 0;
        overflow: hidden;
        width: 100px;
        padding-top: 4px;
        padding-bottom: 4px;

        ::v-deep {
            .isc-dropdown-menu__item {
                color: #fff;
                line-height: 30px;

                &:hover,
                &:focus {
                    background: #3a3a3a;
                }
            }
        }
    }
}
</style>
